module.exports = __webpack_public_path__ + "static/media/crisp_mint.dd4aa6a9.png";